module.exports = __webpack_public_path__ + "static/img/36.3aa09723.png";